import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

export const ShefDefaultAvatar = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG width='160' height='160' viewBox='0 0 160 160' fill='none' {...props}>
    <circle cx='80' cy='80' r='80' fill='#E4E4E4' />
    <mask
      id='mask0_1107_28990'
      style={{ maskType: 'luminance' }}
      maskUnits='userSpaceOnUse'
      x='43'
      y='65'
      width='74'
      height='29'>
      <Path fill-rule='evenodd' clip-rule='evenodd' d='M43 65H117V94H43V65Z' fill='white' />
    </mask>
    <g mask='url(#mask0_1107_28990)'>
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M96.9966 65.5471C96.9966 67.4393 95.4373 68.9733 93.5139 68.9733C91.5905 68.9733 90.0312 67.4393 90.0312 65.5471H96.9966Z'
        fill='#383838'
      />
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M52.0894 81.6352C55.2133 82.3146 59.2707 83.592 59.1899 87.8631C59.1899 89.7792 58.4198 91.2955 56.9182 92.3731C55.4165 93.4507 53.5497 94.0097 51.2782 94.0097C47.2605 94.0097 44.2984 92.2544 43 89.3388L46.7732 87.1836C47.4638 89.0998 48.9654 90.0588 51.2782 90.0588C53.5911 90.0588 54.7261 89.2998 54.7261 87.8225C54.7261 86.5451 53.0227 85.786 50.8719 85.2676C47.8289 84.5087 43.7302 83.3125 43.8111 79.1194C43.8111 77.2844 44.5017 75.8071 45.9208 74.689C47.3416 73.5709 49.1273 73.0117 51.237 73.0117C54.6054 73.0117 57.3229 74.5687 58.7437 77.1641L55.0514 79.2006C54.3608 77.6826 53.0624 76.9253 51.237 76.9253C49.5734 76.9253 48.2749 77.6437 48.2749 79.0397C48.2749 80.3579 49.9798 81.0373 52.0894 81.6352Z'
        fill='#383838'
      />
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M80.2911 81.2353V93.4912H75.9098V81.6741C75.9098 78.6804 74.1636 77.0439 71.3652 77.0439C68.2809 77.0439 66.2109 78.9211 66.2109 82.7924V93.4912H61.8281V65.5471H66.2109V76.0865C67.5506 74.0503 69.619 73.0117 72.5001 73.0117C77.1671 73.0117 80.2911 76.1256 80.2911 81.2353Z'
        fill='#383838'
      />
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M99.5404 81.835C98.9324 78.6009 96.6196 76.9253 93.7385 76.9253C90.4923 76.9253 88.2192 78.8009 87.6112 81.835H99.5404ZM87.6507 85.3473C88.3001 88.3814 90.7764 90.0588 94.1431 90.0588C96.4562 90.0588 98.2023 89.2202 99.3785 87.5835L102.99 89.659C101.001 92.5729 98.0387 94.0097 94.1036 94.0097C90.8161 94.0097 88.1382 93.0118 86.1096 91.0567C84.0809 89.0608 83.0664 86.5451 83.0664 83.5108C83.0664 80.5171 84.0809 78.0418 86.0682 76.046C88.0573 74.0096 90.6542 73.0117 93.7782 73.0117C96.7401 73.0117 99.1753 74.0503 101.082 76.0866C102.99 78.1215 103.963 80.6372 103.963 83.5513C103.963 83.9902 103.923 84.5899 103.801 85.3473H87.6507Z'
        fill='#383838'
      />
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M117.001 69.1798C113.794 68.9003 112.211 70.2183 112.211 73.1324V73.5321H117.001V77.6829H112.211V93.4915H107.83V77.6829H104.746V73.5321H107.83V73.1324C107.83 67.6634 110.996 64.6698 117.001 65.029V69.1798Z'
        fill='#383838'
      />
    </g>
  </SVG>
);
